import React, { useState } from "react";
import classes from "./Sections.module.css";
import promix from "../../Assets/Promix.svg";
import mix from "../../Assets/mix.svg";
import solve from "../../Assets/solve.svg";
import bar from "../../Assets/bar.svg";
import carts from "../../Assets/carts.svg";
import folder from "../../Assets/folder.svg";
import { useNavigate } from "react-router-dom";

const Sections = () => {
  const navigate = useNavigate();
  const [selectedModule, setSelectedModule] = useState("");

  const handleSelection = (moduleId) => {
    setSelectedModule(moduleId);

    switch (moduleId) {
      case "accounting":
        navigate("/modules/Accounting/Dashboard");
        break;
      case "payroll":
        navigate("/modules/PayRoll/Dashboard");
        break;
      case "inventory":
        navigate("/modules/Inventory/Dashboard");
        break;
      case "fixedassets":
        navigate("/modules/FixedAssets/Dashboard");
        break;
      default:
        alert("Invalid module selection.");
    }
  };

  return (
    <div>
      <div className={classes.vitchri}>
        <div>
          <img src={promix} alt="Promix Logo" />
        </div>

        <div className={classes.busy}>
          <p className={classes.gate}>Features</p>
          <p className={classes.gate}>Pricing</p>
          <p className={classes.gate}>Resources</p>
          <p className={classes.prient}>Step 2 of 2</p>
          <img src={mix} alt="Mix Logo" />
          <button className={classes.bu_tton}>Start Free Trial</button>
        </div>
      </div>

      <div className={classes.pirates}>Choose Your Modules</div>

      <p className={classes.ship}>
        Select the modules you need for your business.
        <br />
        You can always add more later.
      </p>

      <div className={classes.sreter}>
        <div className={classes.conpers}>
          <div
            className={classes.gene}
            onClick={() => handleSelection("accounting")}
          >
            <div className={classes.conjurn}>
              <img src={solve} alt="Accounting Icon" />
              <input
                type="checkbox"
                className={classes.ponder}
                checked={selectedModule === "accounting"}
                readOnly
              />
            </div>
            <p className={classes.prute}>Accounting</p>
            <p className={classes.pushte}>
              Complete financial management and bookkeeping
            </p>
          </div>

          <div
            className={classes.gene}
            onClick={() => handleSelection("payroll")}
          >
            <div className={classes.conjurn}>
              <img src={bar} alt="Payroll Icon" />
              <input
                type="checkbox"
                className={classes.ponder}
                checked={selectedModule === "payroll"}
                readOnly
              />
            </div>
            <p className={classes.prute}>Pay Roll</p>
            <p className={classes.pushte}>
              Manage invoices, quotes, and customer relationships
            </p>
          </div>

          <div
            className={classes.gene}
            onClick={() => handleSelection("inventory")}
          >
            <div className={classes.conjurn}>
              <img src={carts} alt="Inventory Icon" />
              <input
                type="checkbox"
                className={classes.ponder}
                checked={selectedModule === "inventory"}
                readOnly
              />
            </div>
            <p className={classes.prute}>Inventory</p>
            <p className={classes.pushte}>
              Track expenses, bills, and vendor management
            </p>
          </div>
        </div>

        <div className={classes.conpers}>
          <div
            className={classes.gene}
            onClick={() => handleSelection("fixedassets")}
          >
            <div className={classes.conjurn}>
              <img src={folder} alt="Fixed Assets Icon" />
              <input
                type="checkbox"
                className={classes.ponder}
                checked={selectedModule === "fixedassets"}
                readOnly
              />
            </div>
            <p className={classes.prute}>Fixed Assets</p>
            <p className={classes.pushte}>
              Monitor outstanding payments and collections
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Sections;
